import React from 'react';
import axios from 'axios';
import { Button, notification } from 'antd';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const DownloadReportButton: React.FC = () => {
    const { instance, accounts } = useMsal();

    const baseURL = process.env.REACT_APP_API_URL;

    const sanitizeFilename = (filename: string) => {
        // Replace any unsafe characters with a safe alternative
        return filename.replace(/[^\w\s.-]/gi, '');
    };

    const downloadReport = async () => {
        try {
            const res = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0]
            });

            const response = await axios.post(`${baseURL}/api/nominations/download`, {}, {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${res.idToken}`,
                },
            });

            // Validate the content type
            const contentType = response.headers['content-type'];
            if (contentType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                throw new Error('Invalid content type');
            }

            const blob = new Blob([response.data], { type: contentType });
            const reader = new FileReader();

            reader.onload = () => {
                const url = reader.result as string;
                const filename = `Awards_${new Date().toISOString()}.xlsx`;
                const sanitizedFilename = sanitizeFilename(filename);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', sanitizedFilename);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);

                notification.success({
                    message: 'Success',
                    description: 'The report has been downloaded successfully.',
                });
            };

            reader.onerror = () => {
                notification.error({
                    message: 'Error',
                    description: 'There was an error processing the report.',
                });
            };

            reader.readAsDataURL(blob);

        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'There was an error downloading the report.',
            });
        }
    };

    return (
        <Button type="primary" onClick={downloadReport}>
            Download Report
        </Button>
    );
};

export default DownloadReportButton;
